<template>
    <div class="flex column" v-title data-title="问题详情">
      <span style="margin: 21px 0 0 26px; font-weight: bold; font-size: 18px; word-wrap: initial">{{this.question.title}}</span>
      <span v-if="this.question.detailTitle" style="margin: 14px 0 0 26px; font-weight: normal; font-size: 17px; word-wrap: initial">{{this.question.detailTitle}}</span>
      <div style="margin: 14px 26px 0 26px; font-weight: normal; font-size: 15px; word-break:break-all;">
        <div v-for="(item, index) in question.detailTexts" :key="index">
          <p v-if="item.title && question.title === '为什么找不到自己的学校？'">{{item.title}}<a style="color: #21BEA1" href="tel:029-89875100">029-89875100</a></p>
          <p v-else-if="item.title">{{item.title}}</p>
          <img style="width: 100%; height: auto" v-if="item.img" :src=item.img>
        </div>
      </div>


    </div>
</template>

<script>
    export default {
        name: "QuestionDetail",
      data () {
          return {
            question: JSON.parse(this.$route.params.question)
          }
      },
      created() {
          console.log(this.question)
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuestionDetail.vue